import { frontendURL } from '../../../helper/URLHelper';
import ClientPortalsIndex from './pages/ClientPortalsIndex.vue';
import ClientPortalEditor from './pages/ClientPortalEditor.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/client_portals'),
    name: 'client_portals_index',
    component: ClientPortalsIndex,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/client_portals/:portalId/edit'),
    name: 'client_portals_edit',
    component: ClientPortalEditor,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
